/**
 * Indonesian provinces and their regencies/cities (kabupaten/kota), for every cascading
 * province → city select: the project survey, architect onboarding and the architect profile.
 *
 * All 38 provinces and 514 kabupaten/kota per Kepmendagri No. 300.2.2-2430 Tahun 2025
 * (taken from github.com/cahyadsn/wilayah). Kabupaten are written "Kab. X" so a regency and the
 * city of the same name ("Kab. Bandung", "Kota Bandung") stay distinct.
 *
 * Province is stored as a code, because its name may be translated; city is stored as the list
 * item itself, because place names don't translate.
 */

export const PROVINCES = [
  { value: 'ACEH', label: 'Aceh' },
  { value: 'SUMATERA_UTARA', label: 'Sumatera Utara' },
  { value: 'SUMATERA_BARAT', label: 'Sumatera Barat' },
  { value: 'RIAU', label: 'Riau' },
  { value: 'JAMBI', label: 'Jambi' },
  { value: 'SUMATERA_SELATAN', label: 'Sumatera Selatan' },
  { value: 'BENGKULU', label: 'Bengkulu' },
  { value: 'LAMPUNG', label: 'Lampung' },
  { value: 'BANGKA_BELITUNG', label: 'Kepulauan Bangka Belitung' },
  { value: 'KEPULAUAN_RIAU', label: 'Kepulauan Riau' },
  { value: 'DKI_JAKARTA', label: 'DKI Jakarta' },
  { value: 'JAWA_BARAT', label: 'Jawa Barat' },
  { value: 'JAWA_TENGAH', label: 'Jawa Tengah' },
  { value: 'DI_YOGYAKARTA', label: 'DI Yogyakarta' },
  { value: 'JAWA_TIMUR', label: 'Jawa Timur' },
  { value: 'BANTEN', label: 'Banten' },
  { value: 'BALI', label: 'Bali' },
  { value: 'NUSA_TENGGARA_BARAT', label: 'Nusa Tenggara Barat' },
  { value: 'NUSA_TENGGARA_TIMUR', label: 'Nusa Tenggara Timur' },
  { value: 'KALIMANTAN_BARAT', label: 'Kalimantan Barat' },
  { value: 'KALIMANTAN_TENGAH', label: 'Kalimantan Tengah' },
  { value: 'KALIMANTAN_SELATAN', label: 'Kalimantan Selatan' },
  { value: 'KALIMANTAN_TIMUR', label: 'Kalimantan Timur' },
  { value: 'KALIMANTAN_UTARA', label: 'Kalimantan Utara' },
  { value: 'SULAWESI_UTARA', label: 'Sulawesi Utara' },
  { value: 'SULAWESI_TENGAH', label: 'Sulawesi Tengah' },
  { value: 'SULAWESI_SELATAN', label: 'Sulawesi Selatan' },
  { value: 'SULAWESI_TENGGARA', label: 'Sulawesi Tenggara' },
  { value: 'GORONTALO', label: 'Gorontalo' },
  { value: 'SULAWESI_BARAT', label: 'Sulawesi Barat' },
  { value: 'MALUKU', label: 'Maluku' },
  { value: 'MALUKU_UTARA', label: 'Maluku Utara' },
  { value: 'PAPUA', label: 'Papua' },
  { value: 'PAPUA_BARAT', label: 'Papua Barat' },
  { value: 'PAPUA_SELATAN', label: 'Papua Selatan' },
  { value: 'PAPUA_TENGAH', label: 'Papua Tengah' },
  { value: 'PAPUA_PEGUNUNGAN', label: 'Papua Pegunungan' },
  { value: 'PAPUA_BARAT_DAYA', label: 'Papua Barat Daya' }
]

export const CITIES_BY_PROVINCE = {
  ACEH: [
    'Kab. Aceh Barat',
    'Kab. Aceh Barat Daya',
    'Kab. Aceh Besar',
    'Kab. Aceh Jaya',
    'Kab. Aceh Selatan',
    'Kab. Aceh Singkil',
    'Kab. Aceh Tamiang',
    'Kab. Aceh Tengah',
    'Kab. Aceh Tenggara',
    'Kab. Aceh Timur',
    'Kab. Aceh Utara',
    'Kota Banda Aceh',
    'Kab. Bener Meriah',
    'Kab. Bireuen',
    'Kab. Gayo Lues',
    'Kota Langsa',
    'Kota Lhokseumawe',
    'Kab. Nagan Raya',
    'Kab. Pidie',
    'Kab. Pidie Jaya',
    'Kota Sabang',
    'Kab. Simeulue',
    'Kota Subulussalam'
  ],
  SUMATERA_UTARA: [
    'Kab. Asahan',
    'Kab. Batu Bara',
    'Kota Binjai',
    'Kab. Dairi',
    'Kab. Deli Serdang',
    'Kota Gunungsitoli',
    'Kab. Humbang Hasundutan',
    'Kab. Karo',
    'Kab. Labuhanbatu',
    'Kab. Labuhanbatu Selatan',
    'Kab. Labuhanbatu Utara',
    'Kab. Langkat',
    'Kab. Mandailing Natal',
    'Kota Medan',
    'Kab. Nias',
    'Kab. Nias Barat',
    'Kab. Nias Selatan',
    'Kab. Nias Utara',
    'Kab. Padang Lawas',
    'Kab. Padang Lawas Utara',
    'Kota Padangsidimpuan',
    'Kab. Pakpak Bharat',
    'Kota Pematangsiantar',
    'Kab. Samosir',
    'Kab. Serdang Bedagai',
    'Kota Sibolga',
    'Kab. Simalungun',
    'Kota Tanjungbalai',
    'Kab. Tapanuli Selatan',
    'Kab. Tapanuli Tengah',
    'Kab. Tapanuli Utara',
    'Kota Tebing Tinggi',
    'Kab. Toba'
  ],
  SUMATERA_BARAT: [
    'Kab. Agam',
    'Kota Bukittinggi',
    'Kab. Dharmasraya',
    'Kab. Kepulauan Mentawai',
    'Kab. Lima Puluh Kota',
    'Kota Padang',
    'Kota Padang Panjang',
    'Kab. Padang Pariaman',
    'Kota Pariaman',
    'Kab. Pasaman',
    'Kab. Pasaman Barat',
    'Kota Payakumbuh',
    'Kab. Pesisir Selatan',
    'Kota Sawahlunto',
    'Kab. Sijunjung',
    'Kab. Solok',
    'Kota Solok',
    'Kab. Solok Selatan',
    'Kab. Tanah Datar'
  ],
  RIAU: [
    'Kab. Bengkalis',
    'Kota Dumai',
    'Kab. Indragiri Hilir',
    'Kab. Indragiri Hulu',
    'Kab. Kampar',
    'Kab. Kepulauan Meranti',
    'Kab. Kuantan Singingi',
    'Kota Pekanbaru',
    'Kab. Pelalawan',
    'Kab. Rokan Hilir',
    'Kab. Rokan Hulu',
    'Kab. Siak'
  ],
  JAMBI: [
    'Kab. Batanghari',
    'Kab. Bungo',
    'Kota Jambi',
    'Kab. Kerinci',
    'Kab. Merangin',
    'Kab. Muaro Jambi',
    'Kab. Sarolangun',
    'Kota Sungai Penuh',
    'Kab. Tanjung Jabung Barat',
    'Kab. Tanjung Jabung Timur',
    'Kab. Tebo'
  ],
  SUMATERA_SELATAN: [
    'Kab. Banyuasin',
    'Kab. Empat Lawang',
    'Kab. Lahat',
    'Kota Lubuk Linggau',
    'Kab. Muara Enim',
    'Kab. Musi Banyuasin',
    'Kab. Musi Rawas',
    'Kab. Musi Rawas Utara',
    'Kab. Ogan Ilir',
    'Kab. Ogan Komering Ilir',
    'Kab. Ogan Komering Ulu',
    'Kab. Ogan Komering Ulu Selatan',
    'Kab. Ogan Komering Ulu Timur',
    'Kota Pagar Alam',
    'Kota Palembang',
    'Kab. Penukal Abab Lematang Ilir',
    'Kota Prabumulih'
  ],
  BENGKULU: [
    'Kota Bengkulu',
    'Kab. Bengkulu Selatan',
    'Kab. Bengkulu Tengah',
    'Kab. Bengkulu Utara',
    'Kab. Kaur',
    'Kab. Kepahiang',
    'Kab. Lebong',
    'Kab. Mukomuko',
    'Kab. Rejang Lebong',
    'Kab. Seluma'
  ],
  LAMPUNG: [
    'Kota Bandar Lampung',
    'Kab. Lampung Barat',
    'Kab. Lampung Selatan',
    'Kab. Lampung Tengah',
    'Kab. Lampung Timur',
    'Kab. Lampung Utara',
    'Kab. Mesuji',
    'Kota Metro',
    'Kab. Pesawaran',
    'Kab. Pesisir Barat',
    'Kab. Pringsewu',
    'Kab. Tanggamus',
    'Kab. Tulang Bawang',
    'Kab. Tulang Bawang Barat',
    'Kab. Way Kanan'
  ],
  BANGKA_BELITUNG: [
    'Kab. Bangka',
    'Kab. Bangka Barat',
    'Kab. Bangka Selatan',
    'Kab. Bangka Tengah',
    'Kab. Belitung',
    'Kab. Belitung Timur',
    'Kota Pangkal Pinang'
  ],
  KEPULAUAN_RIAU: [
    'Kota Batam',
    'Kab. Bintan',
    'Kab. Karimun',
    'Kab. Kepulauan Anambas',
    'Kab. Lingga',
    'Kab. Natuna',
    'Kota Tanjung Pinang'
  ],
  DKI_JAKARTA: [
    'Kota Jakarta Barat',
    'Kota Jakarta Pusat',
    'Kota Jakarta Selatan',
    'Kota Jakarta Timur',
    'Kota Jakarta Utara',
    'Kab. Kepulauan Seribu'
  ],
  JAWA_BARAT: [
    'Kab. Bandung',
    'Kota Bandung',
    'Kab. Bandung Barat',
    'Kota Banjar',
    'Kab. Bekasi',
    'Kota Bekasi',
    'Kab. Bogor',
    'Kota Bogor',
    'Kab. Ciamis',
    'Kab. Cianjur',
    'Kota Cimahi',
    'Kab. Cirebon',
    'Kota Cirebon',
    'Kota Depok',
    'Kab. Garut',
    'Kab. Indramayu',
    'Kab. Karawang',
    'Kab. Kuningan',
    'Kab. Majalengka',
    'Kab. Pangandaran',
    'Kab. Purwakarta',
    'Kab. Subang',
    'Kab. Sukabumi',
    'Kota Sukabumi',
    'Kab. Sumedang',
    'Kab. Tasikmalaya',
    'Kota Tasikmalaya'
  ],
  JAWA_TENGAH: [
    'Kab. Banjarnegara',
    'Kab. Banyumas',
    'Kab. Batang',
    'Kab. Blora',
    'Kab. Boyolali',
    'Kab. Brebes',
    'Kab. Cilacap',
    'Kab. Demak',
    'Kab. Grobogan',
    'Kab. Jepara',
    'Kab. Karanganyar',
    'Kab. Kebumen',
    'Kab. Kendal',
    'Kab. Klaten',
    'Kab. Kudus',
    'Kab. Magelang',
    'Kota Magelang',
    'Kab. Pati',
    'Kab. Pekalongan',
    'Kota Pekalongan',
    'Kab. Pemalang',
    'Kab. Purbalingga',
    'Kab. Purworejo',
    'Kab. Rembang',
    'Kota Salatiga',
    'Kab. Semarang',
    'Kota Semarang',
    'Kab. Sragen',
    'Kab. Sukoharjo',
    'Kota Surakarta',
    'Kab. Tegal',
    'Kota Tegal',
    'Kab. Temanggung',
    'Kab. Wonogiri',
    'Kab. Wonosobo'
  ],
  DI_YOGYAKARTA: [
    'Kab. Bantul',
    'Kab. Gunungkidul',
    'Kab. Kulon Progo',
    'Kab. Sleman',
    'Kota Yogyakarta'
  ],
  JAWA_TIMUR: [
    'Kab. Bangkalan',
    'Kab. Banyuwangi',
    'Kota Batu',
    'Kab. Blitar',
    'Kota Blitar',
    'Kab. Bojonegoro',
    'Kab. Bondowoso',
    'Kab. Gresik',
    'Kab. Jember',
    'Kab. Jombang',
    'Kab. Kediri',
    'Kota Kediri',
    'Kab. Lamongan',
    'Kab. Lumajang',
    'Kab. Madiun',
    'Kota Madiun',
    'Kab. Magetan',
    'Kab. Malang',
    'Kota Malang',
    'Kab. Mojokerto',
    'Kota Mojokerto',
    'Kab. Nganjuk',
    'Kab. Ngawi',
    'Kab. Pacitan',
    'Kab. Pamekasan',
    'Kab. Pasuruan',
    'Kota Pasuruan',
    'Kab. Ponorogo',
    'Kab. Probolinggo',
    'Kota Probolinggo',
    'Kab. Sampang',
    'Kab. Sidoarjo',
    'Kab. Situbondo',
    'Kab. Sumenep',
    'Kota Surabaya',
    'Kab. Trenggalek',
    'Kab. Tuban',
    'Kab. Tulungagung'
  ],
  BANTEN: [
    'Kota Cilegon',
    'Kab. Lebak',
    'Kab. Pandeglang',
    'Kab. Serang',
    'Kota Serang',
    'Kab. Tangerang',
    'Kota Tangerang',
    'Kota Tangerang Selatan'
  ],
  BALI: [
    'Kab. Badung',
    'Kab. Bangli',
    'Kab. Buleleng',
    'Kota Denpasar',
    'Kab. Gianyar',
    'Kab. Jembrana',
    'Kab. Karangasem',
    'Kab. Klungkung',
    'Kab. Tabanan'
  ],
  NUSA_TENGGARA_BARAT: [
    'Kab. Bima',
    'Kota Bima',
    'Kab. Dompu',
    'Kab. Lombok Barat',
    'Kab. Lombok Tengah',
    'Kab. Lombok Timur',
    'Kab. Lombok Utara',
    'Kota Mataram',
    'Kab. Sumbawa',
    'Kab. Sumbawa Barat'
  ],
  NUSA_TENGGARA_TIMUR: [
    'Kab. Alor',
    'Kab. Belu',
    'Kab. Ende',
    'Kab. Flores Timur',
    'Kab. Kupang',
    'Kota Kupang',
    'Kab. Lembata',
    'Kab. Malaka',
    'Kab. Manggarai',
    'Kab. Manggarai Barat',
    'Kab. Manggarai Timur',
    'Kab. Nagekeo',
    'Kab. Ngada',
    'Kab. Rote Ndao',
    'Kab. Sabu Raijua',
    'Kab. Sikka',
    'Kab. Sumba Barat',
    'Kab. Sumba Barat Daya',
    'Kab. Sumba Tengah',
    'Kab. Sumba Timur',
    'Kab. Timor Tengah Selatan',
    'Kab. Timor Tengah Utara'
  ],
  KALIMANTAN_BARAT: [
    'Kab. Bengkayang',
    'Kab. Kapuas Hulu',
    'Kab. Kayong Utara',
    'Kab. Ketapang',
    'Kab. Kubu Raya',
    'Kab. Landak',
    'Kab. Melawi',
    'Kab. Mempawah',
    'Kota Pontianak',
    'Kab. Sambas',
    'Kab. Sanggau',
    'Kab. Sekadau',
    'Kota Singkawang',
    'Kab. Sintang'
  ],
  KALIMANTAN_TENGAH: [
    'Kab. Barito Selatan',
    'Kab. Barito Timur',
    'Kab. Barito Utara',
    'Kab. Gunung Mas',
    'Kab. Kapuas',
    'Kab. Katingan',
    'Kab. Kotawaringin Barat',
    'Kab. Kotawaringin Timur',
    'Kab. Lamandau',
    'Kab. Murung Raya',
    'Kota Palangkaraya',
    'Kab. Pulang Pisau',
    'Kab. Seruyan',
    'Kab. Sukamara'
  ],
  KALIMANTAN_SELATAN: [
    'Kab. Balangan',
    'Kab. Banjar',
    'Kota Banjarbaru',
    'Kota Banjarmasin',
    'Kab. Barito Kuala',
    'Kab. Hulu Sungai Selatan',
    'Kab. Hulu Sungai Tengah',
    'Kab. Hulu Sungai Utara',
    'Kab. Kotabaru',
    'Kab. Tabalong',
    'Kab. Tanah Bumbu',
    'Kab. Tanah Laut',
    'Kab. Tapin'
  ],
  KALIMANTAN_TIMUR: [
    'Kota Balikpapan',
    'Kab. Berau',
    'Kota Bontang',
    'Kab. Kutai Barat',
    'Kab. Kutai Kartanegara',
    'Kab. Kutai Timur',
    'Kab. Mahakam Ulu',
    'Kab. Paser',
    'Kab. Penajam Paser Utara',
    'Kota Samarinda'
  ],
  KALIMANTAN_UTARA: [
    'Kab. Bulungan',
    'Kab. Malinau',
    'Kab. Nunukan',
    'Kab. Tana Tidung',
    'Kota Tarakan'
  ],
  SULAWESI_UTARA: [
    'Kota Bitung',
    'Kab. Bolaang Mongondow',
    'Kab. Bolaang Mongondow Selatan',
    'Kab. Bolaang Mongondow Timur',
    'Kab. Bolaang Mongondow Utara',
    'Kab. Kep. Siau Tagulandang Biaro',
    'Kab. Kepulauan Sangihe',
    'Kab. Kepulauan Talaud',
    'Kota Kotamobagu',
    'Kota Manado',
    'Kab. Minahasa',
    'Kab. Minahasa Selatan',
    'Kab. Minahasa Tenggara',
    'Kab. Minahasa Utara',
    'Kota Tomohon'
  ],
  SULAWESI_TENGAH: [
    'Kab. Banggai',
    'Kab. Banggai Kepulauan',
    'Kab. Banggai Laut',
    'Kab. Buol',
    'Kab. Donggala',
    'Kab. Morowali',
    'Kab. Morowali Utara',
    'Kota Palu',
    'Kab. Parigi Moutong',
    'Kab. Poso',
    'Kab. Sigi',
    'Kab. Tojo Una Una',
    'Kab. Toli-Toli'
  ],
  SULAWESI_SELATAN: [
    'Kab. Bantaeng',
    'Kab. Barru',
    'Kab. Bone',
    'Kab. Bulukumba',
    'Kab. Enrekang',
    'Kab. Gowa',
    'Kab. Jeneponto',
    'Kab. Kepulauan Selayar',
    'Kab. Luwu',
    'Kab. Luwu Timur',
    'Kab. Luwu Utara',
    'Kota Makassar',
    'Kab. Maros',
    'Kota Palopo',
    'Kab. Pangkajene dan Kepulauan',
    'Kota Parepare',
    'Kab. Pinrang',
    'Kab. Sidenreng Rappang',
    'Kab. Sinjai',
    'Kab. Soppeng',
    'Kab. Takalar',
    'Kab. Tana Toraja',
    'Kab. Toraja Utara',
    'Kab. Wajo'
  ],
  SULAWESI_TENGGARA: [
    'Kota Bau Bau',
    'Kab. Bombana',
    'Kab. Buton',
    'Kab. Buton Selatan',
    'Kab. Buton Tengah',
    'Kab. Buton Utara',
    'Kota Kendari',
    'Kab. Kolaka',
    'Kab. Kolaka Timur',
    'Kab. Kolaka Utara',
    'Kab. Konawe',
    'Kab. Konawe Kepulauan',
    'Kab. Konawe Selatan',
    'Kab. Konawe Utara',
    'Kab. Muna',
    'Kab. Muna Barat',
    'Kab. Wakatobi'
  ],
  GORONTALO: [
    'Kab. Boalemo',
    'Kab. Bone Bolango',
    'Kab. Gorontalo',
    'Kota Gorontalo',
    'Kab. Gorontalo Utara',
    'Kab. Pohuwato'
  ],
  SULAWESI_BARAT: [
    'Kab. Majene',
    'Kab. Mamasa',
    'Kab. Mamuju',
    'Kab. Mamuju Tengah',
    'Kab. Pasangkayu',
    'Kab. Polewali Mandar'
  ],
  MALUKU: [
    'Kota Ambon',
    'Kab. Buru',
    'Kab. Buru Selatan',
    'Kab. Kepulauan Aru',
    'Kab. Kepulauan Tanimbar',
    'Kab. Maluku Barat Daya',
    'Kab. Maluku Tengah',
    'Kab. Maluku Tenggara',
    'Kab. Seram Bagian Barat',
    'Kab. Seram Bagian Timur',
    'Kota Tual'
  ],
  MALUKU_UTARA: [
    'Kab. Halmahera Barat',
    'Kab. Halmahera Selatan',
    'Kab. Halmahera Tengah',
    'Kab. Halmahera Timur',
    'Kab. Halmahera Utara',
    'Kab. Kepulauan Sula',
    'Kab. Pulau Morotai',
    'Kab. Pulau Taliabu',
    'Kota Ternate',
    'Kota Tidore Kepulauan'
  ],
  PAPUA: [
    'Kab. Biak Numfor',
    'Kab. Jayapura',
    'Kota Jayapura',
    'Kab. Keerom',
    'Kab. Kepulauan Yapen',
    'Kab. Mamberamo Raya',
    'Kab. Sarmi',
    'Kab. Supiori',
    'Kab. Waropen'
  ],
  PAPUA_BARAT: [
    'Kab. Fak Fak',
    'Kab. Kaimana',
    'Kab. Manokwari',
    'Kab. Manokwari Selatan',
    'Kab. Pegunungan Arfak',
    'Kab. Teluk Bintuni',
    'Kab. Teluk Wondama'
  ],
  PAPUA_SELATAN: ['Kab. Asmat', 'Kab. Boven Digoel', 'Kab. Mappi', 'Kab. Merauke'],
  PAPUA_TENGAH: [
    'Kab. Deiyai',
    'Kab. Dogiyai',
    'Kab. Intan Jaya',
    'Kab. Mimika',
    'Kab. Nabire',
    'Kab. Paniai',
    'Kab. Puncak',
    'Kab. Puncak Jaya'
  ],
  PAPUA_PEGUNUNGAN: [
    'Kab. Jayawijaya',
    'Kab. Lanny Jaya',
    'Kab. Mamberamo Tengah',
    'Kab. Nduga',
    'Kab. Pegunungan Bintang',
    'Kab. Tolikara',
    'Kab. Yahukimo',
    'Kab. Yalimo'
  ],
  PAPUA_BARAT_DAYA: [
    'Kab. Maybrat',
    'Kab. Raja Ampat',
    'Kab. Sorong',
    'Kota Sorong',
    'Kab. Sorong Selatan',
    'Kab. Tambrauw'
  ]
}

export const citiesFor = province =>
  (CITIES_BY_PROVINCE[province] || []).map(city => ({ value: city, label: city }))

export const provinceLabel = province => PROVINCES.find(p => p.value === province)?.label || ''

// Rows saved before the survey stored codes hold a plain name instead (Google's
// "Daerah Khusus Ibukota Jakarta", or a label); those are shown as they are.
export const displayProvince = value => provinceLabel(value) || value || ''

export const placeLabel = place =>
  [place?.city, displayProvince(place?.province)].filter(Boolean).join(', ')
